import { Grid } from "@mui/material";
import Footer from "../../common/Footer";
import HeaderSec from "../../common/HeaderSec";
import ComingSoonSection from "../ComingSoonSection";


const MembershipRegistration = () => {
  return (
    <Grid>
      <HeaderSec />
      <ComingSoonSection />
      <Footer />
    </Grid>
  );
};

export default MembershipRegistration;
